import React from "react";
import Select from "react-select";
import { Button, Row, Col, Label } from "reactstrap";

const ROLE_OPTIONS = [
  { value: 3, label: "QA" },
  { value: 4, label: "Reviewer" },
];

const CLIENT_TYPE_OPTIONS = [
  { value: "Outsource", label: "Outsource" },
  { value: "Offshore", label: "Offshore" },
  { value: "Outsource with support", label: "Outsource with support" },
];

const JOB_TYPE_OPTIONS = [
  { value: "YE",  label: "YE" },
  { value: "VAT", label: "VAT" },
  { value: "A",   label: "Amendment" },
  { value: "MA",  label: "MA" },
];

const AuditFilterBar = ({
  filters,
  onChange,
  onRefresh,
  showUserPicker = false,
  assignedUsers = [],
  loading = false,
  minimal = false,
  statusOptions = [],
  statusValue = null,
  onStatusChange,
}) => {
  const set = (key) => (value) => onChange({ ...filters, [key]: value });

  if (minimal) {
    return (
      <div className="p-3 mb-3 d-flex justify-content-between align-items-end" style={{ background: "#f6f9fc", borderRadius: 6 }}>
        <div style={{ minWidth: 220 }}>
          <Label className="form-control-label" style={{ fontSize: 12 }}>Status</Label>
          <Select
            isClearable
            placeholder="All statuses"
            options={statusOptions}
            value={statusValue}
            onChange={onStatusChange}
          />
        </div>
        <Button color="primary" size="sm" onClick={onRefresh} disabled={loading}>
          {loading ? "Refreshing…" : "Refresh"}
        </Button>
      </div>
    );
  }

  return (
    <div className="p-3 mb-3" style={{ background: "#f6f9fc", borderRadius: 6 }}>
      <Row className="g-2">
        {showUserPicker && (
          <Col md="3" sm="6" className="mb-2">
            <Label className="form-control-label" style={{ fontSize: 12 }}>Manager / User</Label>
            <Select
              isClearable
              placeholder="All direct reports"
              options={assignedUsers.map((u) => ({ value: u.id, label: u.name }))}
              value={filters.selected_user || null}
              onChange={set("selected_user")}
            />
          </Col>
        )}

        <Col md="2" sm="6" className="mb-2">
          <Label className="form-control-label" style={{ fontSize: 12 }}>Role</Label>
          <Select
            isClearable
            placeholder="All roles"
            options={ROLE_OPTIONS}
            value={filters.role || null}
            onChange={set("role")}
          />
        </Col>

        <Col md="2" sm="6" className="mb-2">
          <Label className="form-control-label" style={{ fontSize: 12 }}>Client Type</Label>
          <Select
            isMulti
            placeholder="All"
            options={CLIENT_TYPE_OPTIONS}
            value={filters.client_types || []}
            onChange={set("client_types")}
          />
        </Col>

        <Col md="2" sm="6" className="mb-2">
          <Label className="form-control-label" style={{ fontSize: 12 }}>Job Type</Label>
          <Select
            isMulti
            placeholder="All"
            options={JOB_TYPE_OPTIONS}
            value={filters.job_types || []}
            onChange={set("job_types")}
          />
        </Col>

        <Col md="3" sm="6" className="mb-2">
          <Label className="form-control-label" style={{ fontSize: 12 }}>Status</Label>
          <Select
            isClearable
            placeholder="All statuses"
            options={statusOptions}
            value={statusValue}
            onChange={onStatusChange}
          />
        </Col>
      </Row>

      <div className="d-flex justify-content-end mt-2">
        <Button color="primary" size="sm" onClick={onRefresh} disabled={loading}>
          {loading ? "Refreshing…" : "Refresh"}
        </Button>
      </div>
    </div>
  );
};

export default AuditFilterBar;
